// @flow
import React from 'react';
import styled from 'styled-components';
import { media } from 'styles/Mixins';
import { HomeApplication } from 'utils/ExportCommon';
import { StyledScreenOverlay } from 'styles/Modals';

const ModalWindow = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
  position: fixed;
  z-index: 100;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
  background-color: #fefefe;
  margin: auto;
  padding: 40px 50px;
  border: 1px solid #888;
  color: red;
  width: 500px;
  border-radius: 2px;
  background-color: #278c7e;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  ${media.xs`
    width: 345px;
    min-height: 324px;
    padding: 30px 45px;
  `}
`;

const Text = styled.p`
  font-size: ${({ size = '12' }) => size}px;
  font-weight: ${({ weight = 'normal' }) => weight};
  margin: ${({ margin = '0 0 10px' }) => margin};
  color: ${({ color = '#ffffff' }) => color};
  text-align: ${({ align = 'center' }) => align};
`;

const UserOptions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

const UserOption = styled.button`
  background-color: ${props => (props.transparent ? 'transparent' : '#fff')};
  color: ${props => (props.transparent ? '#fff' : '#278C7E')};
  outline: none;
  border: none;
  font-size: 16px;
  font-weight: bold;
  border-radius: 2px;
  line-height: 17px;
  padding: 8px ${props => (props.transparent ? '0' : '16px')};
`;

const ImgContent = styled.div`
  margin-left: calc(50% - 82.5px);
  height: 165px;
  width: 165px;
  background-color: #ffffff;
  border-radius: 50%;
  ${media.xs`
    margin: 0 auto;
  `}
`;

type PropsTypes = {
  title: string,
  message: string,
  show: boolean,
  timerClose: number,
  autoClose: boolean,
  handleCloseModal: () => void,
  onClickButtonCancel?: () => void,
  onClickButtonContinue?: () => void,
  icon?: any
};

class CancelProcessModal extends React.PureComponent<PropsTypes> {
  static defaultProps = {
    title: '',
    message: '',
    autoClose: false,
    show: false,
    timerClose: 5000,
    handleCloseModal: () => {},
    onClickButtonCancel: () => {},
    onClickButtonContinue: () => {}
  };

  constructor(props: PropsTypes) {
    super(props);
    this.timer = null;
  }

  closeModal = () => {
    this.timer = setTimeout(() => {
      this.props.handleCloseModal();
      clearTimeout(this.timer);
    }, this.props.timerClose);
  };

  onClickButtonCancel = () => {
    this.props.onClickButtonCancel();
    this.props.handleCloseModal();
  };

  onClickButtonContinue = () => {
    this.props.onClickButtonContinue();
    this.props.handleCloseModal();
  };

  render() {
    let { show, title, message, autoClose } = this.props;
    if (show) {
      if (autoClose) {
        this.closeModal();
      }
    }

    return (
      <StyledScreenOverlay show={this.props.show}>
        <ModalWindow visible>
          <ModalContent alignItems="center" justifyContent="center">
            <ImgContent>
              <img
                style={{
                  height: '100px',
                  marginTop: '35px',
                  marginLeft: '32px'
                }}
                src={HomeApplication.ThinkingFace}
              />
            </ImgContent>
            <Text size={17} margin="20px 0 20px">
              {title}
            </Text>
            <UserOptions>
              <UserOption onClick={this.onClickButtonContinue} transparent>
                {message}
              </UserOption>
              <UserOption onClick={this.onClickButtonCancel}>
                Cancelar aplicación
              </UserOption>
            </UserOptions>
          </ModalContent>
        </ModalWindow>
      </StyledScreenOverlay>
    );
  }
}

export default CancelProcessModal;
